import React from 'react'
import {Container, Row } from 'react-bootstrap';
import './Skill.css';
import html from './html.png';
import css from './css.png';
import js from './js-file.png';
import ts from './typescript.png';
import bootstrap from './bootstrap.png';
import sass from './sass.png';
import githup from './github.png';
import react from './atom.png';
import java from './java.png';
import c from './c.png';
import api from './api.png';
import angular from './angular.png';



const Skill = () => {
  return (
    <div className='skill'>
        <Container  >
        <Row xs={2} md={6}>
                    <div>
                        <img src={html} alt="html"/>
                        <br />
            <h2>HTML</h2>                    </div>

            <div>
                        <img src={css} alt="css"/>
                        <br />
            <h2>CSS</h2>                    </div>

            <div>
                        <img src={js} alt="js"/>
                        <br />
            <h2>JS</h2>                    </div>

            <div>
                        <img src={ts} alt="ts"/>
                        <br />
            <h2>TYPESCRIPT</h2>                    </div>

             <div>
                        <img src={react} alt="react"/>
                        <br />
            <h2>React Js</h2>                    </div>
            <div>
                        <img src={angular} alt="angular"/>
                        <br />
            <h2>Angular</h2>                    </div>
            </Row>
            <Row xs={2} md={6}>

            <div>
                        <img src={java} alt="java"/>
                        <br />
            <h2>Java</h2>                    </div>  
            
            <div>
                        <img src={c} alt="c#"/>
                        <br />
            <h2>C#</h2>                    </div>

            <div>
                        <img src={bootstrap} alt="bootstrap"/>
                        <br />
            <h2>Bootstrap</h2>                    </div>
            
            <div>
                        <img src={sass} alt="sass"/>
                        <br />
            <h2>Sass</h2>                    </div>
            
            <div>
                        <img src={githup} alt="githup"/>
                        <br />
            <h2>github</h2>                    </div>
            <div>
                        <img src={api} alt="react"/>
                        <br />
            <h2>Deailng with API</h2>                    </div>
                </Row>

        </Container>
    </div>
  )
}

export default Skill